import React from 'react';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Add } from '@mui/icons-material';

import { Icons } from '../../../../../../../Themes';
import EmptyState from '../../../../../../DesignSystem/EmptyState';
import CustomIcon from '../../../../../../DesignSystem/CustomIcon';
import { PostTypes } from '../../../../../../../Utils/Types';
import { isSubmissionStep } from '../../../../../../../Utils/Types/Steps';
import { loginPath, newPostPath } from '../../../../../../../Utils/routes';
import ContributionLabel from '../../../../../Shared/InteractionsBox/ContributionLabel';
import useCurrentUser from '../../../../../../../Hooks/useCurrentUser';

function EmptyOngoing({ post, space, activeStep }: any) {
  const { isLoggedIn } = useCurrentUser();
  const openToCitizenAndContributor = activeStep.open_to_citizen_and_contributor;
  const canSubmitProposals =
    isSubmissionStep(activeStep.step_type) && post.permissions.can_create_ideas;

  const postFormPath = newPostPath(space.slug, PostTypes.IDEA, { parent_id: post.id });

  const action = (
    <Button
      variant="contained"
      color="primary"
      size="large"
      component={Link}
      startIcon={<Add />}
      to={isLoggedIn ? postFormPath : loginPath(postFormPath)}
    >
      <ContributionLabel
        contributionKind={post.config?.contribution_kind}
        contributionKindLabel={post.config?.contribution_kind_label}
      />
    </Button>
  );

  const renderTitle = () => {
    if (!canSubmitProposals) {
      return (
        <FormattedMessage
          id="POSTS.CONSULTATIONS.FEED_TITLE.IDEAS_COUNT"
          values={{ itemCount: 0 }}
        />
      );
    }

    if (!openToCitizenAndContributor) {
      return <FormattedMessage id="POSTS.CONSULTATIONS.PARTICIPATE_OFF" />;
    }

    return <FormattedMessage id="POSTS.CONSULTATIONS.BE_THE_FIRST_TO_PARTICIPATE" />;
  };

  return (
    <EmptyState
      content={<Typography variant="body1">{renderTitle()}</Typography>}
      icon={<CustomIcon src={Icons.misc.bulb} color="primary" size={30} />}
      action={canSubmitProposals ? action : null}
    />
  );
}

export default EmptyOngoing;
